import { createEvent } from "effector";
import { TRequestParams } from "../../../shared/commonTypes/commonTypes";

export const initPage = createEvent<URLSearchParams>();
export const setInitializing = createEvent();
export const setQuery = createEvent<TRequestParams>();
export const resetToken = createEvent();
export const resetQuery = createEvent();
